import styled from 'styled-components';

/**
 * @url https://css-tricks.com/the-shapes-of-css/#aa-egg-shape
 */
export const BarChartIndicatorSC = styled.div<{ color: string; left: string }>`
  background-color: antiquewhite;

  position: relative;

  .big {
    position: absolute;
    left: ${({ left }) => left};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15px;
    height: 19px;
    background-color: white;
    border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
    transform: rotate(180deg) translateX(50%);
    top: -15px;
  }

  .small {
    display: block;
    width: 10px;
    height: 14px;
    background-color: ${({ color }) => color};
    border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  }
`;
